module.exports = __webpack_public_path__ + "static/media/AI文本banner.9a7c462b.jpg";